import { GetReportConfig } from 'domain/usecases/get-report-config';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetReportConfig extends BaseHttpService<GetReportConfig.Model> implements GetReportConfig {
  async getReportConfig({ locationId }: GetReportConfig.Params): Promise<GetReportConfig.Model> {
    return await this.request('get', {}, { locationId });
  }
}
